
import { defineComponent, onMounted, ref, watch } from 'vue'
import RacesTable from './RacesTable.vue';
import { isLoading } from '../../utils/loading';

import { http, EthersService as eth } from '../../services';
import { QueueModel, FindAllResponse } from '../../../../common';
import { commitedFilters, filtersChanged, filtersModel, maxTicketPrice, minTicketPrice } from './race-filters';
import { defaultPageSize } from '@/data/global';
import breakpoints from '../../utils/breakpoints';

export default defineComponent({
  components: { RacesTable },
  setup() {
    const races = ref<QueueModel[]>([]);
    const totalRaces = ref(0);

    const page = ref(1);
    const pageSize = ref(defaultPageSize.value);

    const search = () => {
      page.value = 1;
      commitedFilters.value = { ...filtersModel };
      resetData();
    };

    const resetFilters = () => {
      page.value = 1;
      pageSize.value = defaultPageSize.value;
      Object.keys(filtersModel).forEach(k => {
        filtersModel[k] = null;
      });
      maxTicketPrice.value = null;
      minTicketPrice.value = null;
      search();
    }

    const resetData = (): void => {
      http.getQueues({
        name: commitedFilters.value.title,
        surfaceType: commitedFilters.value.surfaceType,
        distanceType: commitedFilters.value.distanceType,
        weatherType: commitedFilters.value.weatherType,
        arenaType: commitedFilters.value.arena,
        totalParticipants: commitedFilters.value.totalParticipants,
        limit: pageSize.value,
        offset: (page.value - 1) * pageSize.value,
        orderBy: commitedFilters.value.ticketOrder !== null ? `entryFee-${commitedFilters.value.ticketOrder}` : 'createdAt-DESC',
        owner: eth.userAddress
      }).then((res: FindAllResponse<QueueModel>) => {
        races.value = res.data;
        totalRaces.value = res.total;
      })
    };

    watch(() => page.value, (_) => resetData());
    watch(() => [pageSize.value, maxTicketPrice.value, minTicketPrice.value], (_) => {
      if (page.value !== 1) page.value = 1;
      else resetData();
    });

    onMounted(() => {
      resetData();
    });

    const onJoined = () => {
      resetData();
    };

    const onUnenqueued = () => {
      resetData();
    };

    return {
      races,
      totalRaces,
      page,
      pageSize,
      isLoading,
      search,
      resetFilters,
      onJoined,
      onUnenqueued,
      filtersChanged,
      breakpoints
    };
  },
})
